import { SystemRecommendationSelectionsEntry } from 'features/structure/structure-slice';
import axios from 'utils/api';
import { PtacPreferencesRecord } from '@alpinehomeair/common';
import { RecommendationSelections } from 'utils/recommendations-strip-logic';

export function buildPtacPreferencesSelectionsPayload(
  entry: SystemRecommendationSelectionsEntry | null | undefined,
  ptac: PtacPreferencesRecord
): RecommendationSelections {
  const payload: RecommendationSelections = {
    wantIds: entry?.wantIds ?? [],
    haveId: entry?.haveId ?? null,
    refrigerant: entry?.refrigerant ?? null,
    age: entry?.age ?? null,
    ptac
  };
  if (entry) {
    if (entry.useRecommendations !== undefined) {
      payload.useRecommendations = entry.useRecommendations;
    }
    if (entry.fingerprint !== undefined) {
      payload.fingerprint = entry.fingerprint;
    }
    if (entry.virtualCodes !== undefined) {
      payload.virtualCodes = entry.virtualCodes;
    }
    if (entry.virtualFuel !== undefined) {
      payload.virtualFuel = entry.virtualFuel;
    }
    if (entry.tonnage) {
      payload.tonnage = entry.tonnage;
    }
  }
  return payload;
}

export async function persistPtacPreferences(
  systemUniqueId: string,
  entry: SystemRecommendationSelectionsEntry | null | undefined,
  ptac: PtacPreferencesRecord
): Promise<void> {
  try {
    await axios.patch(
      `existing-equipment/${systemUniqueId}/recommendation-selections`,
      buildPtacPreferencesSelectionsPayload(entry, ptac)
    );
  } catch (error) {
    console.error('Error saving PTAC preferences:', error);
  }
}
